import { Controller } from "@hotwired/stimulus"

/**
 * Project Display Controller
 * Updates the project number display when a project is selected
 */
export default class extends Controller {
  static targets = ["projectNumber"]

  connect() {
    console.log('[project-display] Controller connected')

    // Find the project select element
    this.projectSelect = this.element.querySelector('#set-project-number')

    if (this.projectSelect) {
      // Listen for changes (both native and Select2)
      this.projectSelect.addEventListener('change', this.updateProjectNumber.bind(this))

      // Listen for Select2 change event if jQuery is available
      if (window.jQuery) {
        window.jQuery(this.projectSelect).on('select2:select', this.updateProjectNumber.bind(this))
      }

      // Trigger initial update if a project is already selected
      if (this.projectSelect.value) {
        this.updateProjectNumber()
      }
    }
  }

  disconnect() {
    if (this.projectSelect) {
      this.projectSelect.removeEventListener('change', this.updateProjectNumber.bind(this))

      // Clean up Select2 event listener if jQuery is available
      if (window.jQuery) {
        window.jQuery(this.projectSelect).off('select2:select', this.updateProjectNumber.bind(this))
      }
    }
  }

  async updateProjectNumber() {
    const projectId = this.projectSelect.value

    if (!projectId) {
      this.projectNumberTarget.textContent = 'N/A'
      return
    }

    try {
      const response = await fetch(`/projects/${projectId}.json`)
      if (!response.ok) throw new Error('Failed to fetch project data')

      const data = await response.json()

      if (data.project_number && data.project_number !== '') {
        this.projectNumberTarget.textContent = data.project_number
      } else {
        this.projectNumberTarget.textContent = 'N/A'
      }

      console.log('[project-display] Project number updated:', data.project_number)
    } catch (error) {
      console.error('[project-display] Error fetching project number:', error)
      this.projectNumberTarget.textContent = 'N/A'
    }
  }
}
